export enum USER {
    /**
     * @value Account type
     */
    ACCOUNT_TYPE = 'ADMIN.ACCOUNT_TYPE',
    /**
     * @value Platform groups
     */
    CUSTOMER_FEEDS = 'ADMIN.NAV.CUSTOMER_FEEDS',
    /**
     * @value Exit view mode
     */
    EXIT_VIEW_MODE = 'USER.EXIT_VIEW_MODE',
    /**
     * @value Default groups
     */
    FEED_GROUP_TECHNICAL = 'FEED_GROUP_TECHNICAL',
    /**
     * @value {"one":"Inactive user","other":"Inactive users"}
     */
    INACTIVE_USERS = 'USER.INACTIVE_USERS',
    /**
     * @value %USER_NAME% (inactive)
     * @description Inactive suffix for displaying inactive usernames
     */
    INACTIVE_USER_SUFFIX = 'USER.INACTIVE_USER_SUFFIX',
    /**
     * @value Sign in
     */
    LOGIN_CLASSIC_SIGN_IN = 'LOGIN_CLASSIC_SIGN_IN',
    /**
     * @value Select a group and press “Enter”
     * @description Description for a select component where the user can select groups of peoples.
     */
    SELECT_GROUP_PRESS_ENTER = 'USER.GROUPPICKER.SELECT_GROUP_PRESS_ENTER',
    /**
     * @value Show user details
     */
    SHOW_PROFILE_PREVIEW = 'USER.SHOW_PROFILE_PREVIEW',
    /**
     * @value Show user's profile
     */
    SHOW_USER_PROFILE = 'FRONT.WIDGET_DELVE.SETTINGS.LABEL.IS_CONNECTED_USER_DISPLAYED',
    /**
     * @value Add people
     * @description Label of an user picker
     */
    USERPICKER_ADD_PEOPLE = 'USER.USERPICKER.ADD_PEOPLE',
    /**
     * @value Press enter to add people.
     */
    USERPICKER_HELPER = 'USER.USERPICKER.HELPER',
    /**
     * @value User management
     */
    USERS_MANAGEMENT = 'ADMIN.NAV.USERS_MANAGEMENT',
    /**
     * @value Display cell phone
     * @description tooltip of the action button of a user card that lets one visualise another user's cell phone number
     */
    USER_CARD_ACTION_TOOLTIP_CELLPHONE = 'FRONT.USER_CARD.ACTION_TOOLTIP.CELLPHONE',
    /**
     * @value Send an email
     * @description tooltip of the action button of a user card that lets a user send an email to another user
     */
    USER_CARD_ACTION_TOOLTIP_EMAIL = 'FRONT.USER_CARD.ACTION_TOOLTIP.EMAIL',
    /**
     * @value Display office phone
     * @description tooltip of the action button of a user card that lets one visualise another user's office phone number
     */
    USER_CARD_ACTION_TOOLTIP_PHONE = 'FRONT.USER_CARD.ACTION_TOOLTIP.PHONE',
    /**
     * @value Logout
     */
    USER_SETTINGS_LOGOUT = 'USER_SETTINGS_LOGOUT',
    /**
     * @value Viewing as %USER%
     */
    VIEWING_AS_USER = 'USER.VIEWING_AS_USER',
}
